module.exports = __webpack_public_path__ + "static/media/card-game.c4f63c19.svg";